import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Applies the Current List params as soon as the dimension-filter plugin
 * writes an edited filter, so a filter change takes effect immediately rather
 * than waiting for a separate apply step.
 */
export const applyFiltersOnSelection = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    collection.plugins.currentListPlugin.editedParams.actions.setFilters.success
      .observe()
      .pipe(
        rxjs.map(action =>
          collection.plugins.currentListPlugin.feature.actions.applyParams
            .from(action)
            .create(),
        ),
      ),
)
